import React from "react";
import { Outlet } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/landing/Footer";
import { ScrollToTop } from "@/components/ScrollToTop";
import { MobileStickyCTA } from "@/components/landing/MobileStickyCTA";
import { useLead } from "@/context/LeadContext";

export const Layout = () => {
  const { openForm } = useLead();
  return (
    <div className="App min-h-screen bg-background">
      <ScrollToTop />
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer onReserve={openForm} />
      <div className="h-20 md:hidden" aria-hidden="true" />
      <MobileStickyCTA />
    </div>
  );
};
